import * as React from 'react'

import { useActions } from './useActions'
import { BulkActionButton } from '../BulkActionButton'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import { CustomActionBar } from '@sales-center/components'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  recordCount: number
  saveCallback: (date: Date | null, updateExpected: boolean) => Promise<boolean>
  hasPermission: boolean
  entityType: ENTITY_TYPES
}

export const BulkUpdateNextActionDate: React.FC<Props> = (props) => {
  const { hasPermission, entityType } = props

  const {
    open,
    onOpen,
    onClose,
    nextActionDate,
    onChange,
    onAccept,
    onCloseDialog,
    onClear,
    setUpdateExpected,
  } = useActions(props)

  return (
    <>
      <MobileDatePicker
        open={open}
        onClose={onClose}
        onAccept={onAccept}
        onChange={onChange}
        //onClear={onClear}
        value={nextActionDate}
        disablePast={false}
        slots={{
          actionBar: CustomActionBar,
          textField: () => (
            <BulkActionButton
              onClick={onOpen}
              type="updateNextActionDate"
              hasPermission={hasPermission}
              errorString="You do not have permissions to perform bulk updates."
              helperText="Mass update the next action date for selected records."
            >
              Next Action Date
            </BulkActionButton>
          ),
        }}
        slotProps={{
          actionBar: {
            /*eslint-disable */
            //@ts-ignore
            isnextactiondate: 'nextaction',
            disabled: !nextActionDate,
            setupdateotherdate: setUpdateExpected,
            entitytype: entityType,
            onClear: onClear,
            actions: ['clear', 'cancel', 'accept'],
          },

          toolbar: {
            hidden: true,
          },

          dialog: {
            onClose: onCloseDialog,
          },
        }}
      />
    </>
  )
}
BulkUpdateNextActionDate.displayName = 'BulkUpdateNextActionDate'
